import { Plus, X } from "lucide-react"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Label } from "@/components/ui/label"
import { INTEGRATION_REGISTRY } from "@/lib/integration-registry"

interface AgentIntegrationsFormProps {
  kinds: string[]
  onKindsChange: (kinds: string[]) => void
}

export default function AgentIntegrationsForm({
  kinds,
  onKindsChange,
}: AgentIntegrationsFormProps) {
  const availableKinds = Object.keys(INTEGRATION_REGISTRY).filter(
    (k) => !kinds.includes(k),
  )

  const addKind = (kind: string) => {
    onKindsChange([...kinds, kind])
  }

  const removeKind = (kind: string) => {
    onKindsChange(kinds.filter((k) => k !== kind))
  }

  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium">Integrations</Label>

      {kinds.length > 0 && (
        <div className="space-y-2">
          {kinds.map((kind) => {
            const integration = INTEGRATION_REGISTRY[kind]
            if (!integration) return null
            return (
              <div
                key={kind}
                className="flex items-center gap-3 rounded-md border px-3 py-2"
              >
                <div className="bg-muted flex h-10 w-10 items-center justify-center rounded-md">
                  {integration.icon}
                </div>
                <span className="flex-1 text-sm font-medium">
                  {integration.label}
                </span>
                <Button
                  type="button"
                  variant="ghost"
                  size="icon"
                  className="shrink-0"
                  onClick={() => removeKind(kind)}
                >
                  <X className="h-4 w-4" />
                </Button>
              </div>
            )
          })}
        </div>
      )}

      {availableKinds.length > 0 && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button type="button" variant="outline">
              <Plus className="h-4 w-4" />
              Add integration
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start">
            {availableKinds.map((kind) => {
              const integration = INTEGRATION_REGISTRY[kind]
              if (!integration) return null
              return (
                <DropdownMenuItem key={kind} onClick={() => addKind(kind)}>
                  <span className="mr-2 flex h-5 w-5 items-center justify-center">
                    {integration.icon}
                  </span>
                  {integration.label}
                </DropdownMenuItem>
              )
            })}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  )
}
